<template>
  <v-row no-gutters align="center" class="search-wrapper">
    <v-combobox
      ref="autocomplete"
      :id="id"
      :value="value"
      :items="items"
      :placeholder="pHolder | titlecase"
      :item-text="itemText"
      append-icon="search"
      :return-object="false"
      :no-filter="!filter"
      :allow-overflow="true"
      flat
      v-if="autocomplete"
      :loading="loading"
      :menu-props="{ contentClass: menuClass }"
      @click:item="change"
      @click:append="change(value)"
      @change="change"
      @keyup="autocompleteChange"
      :disabled="applyDisable"
      :clearable="applyClearable"
    >
      <template v-slot:item="{ item }">
        <slot name="item" :item="item"
          ><sanimpresa-tooltip
            :isSanimpresa="item?.sanimpresa"
            :tooltipText="'sanimpresaFacilityTooltip'"
            :iconDimension="'25px'"
          ></sanimpresa-tooltip
          >{{ item[itemText] }}</slot
        >
      </template>
      <!-- <template v-slot:selection="{ item, selected, attrs }">
        <span
          v-bind="attrs"
          v-if="selected && isAlias"
          v-html="aliasContent"
        ></span>
        <span v-bind="attrs" v-else-if="selected">{{ item[itemText] }}</span>
      </template> -->
      <template v-slot:no-data>
        <v-row
          no-gutters
          v-if="noItemText && value"
          align="center"
          class="pa-2"
        >
          <v-icon small left color="primary">fas fa-times-circle</v-icon>
          <div class="body-2 font-weight-bold">
            {{ noItemText }}
          </div>
        </v-row>
        <span v-else></span>
      </template>
      <template v-slot:append v-if="loading">
        <v-progress-circular
          size="20"
          width="2"
          indeterminate
          small
          color="primary"
        ></v-progress-circular>
      </template>
    </v-combobox>
    <template v-else>
      <v-text-field
        :value="value"
        :placeholder="pHolder | titlecase"
        solo
        flat
        :loading="loading"
        append-icon="search"
        @click:append="change(value)"
        @keyup.enter="change"
      ></v-text-field>
    </template>
  </v-row>
</template>

<script>
import SanimpresaTooltip from "./SanimpresaTooltip";

export default {
  components: {
    SanimpresaTooltip
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String
    },
    items: {
      type: Array
    },
    itemText: {
      type: String,
      default: ""
    },
    noItemText: {
      type: String,
      default: () => ""
    },
    autocomplete: {
      type: Boolean
    },
    filter: {
      type: Boolean,
      default: false
    },
    search: {
      type: Boolean
    },
    customText: {
      type: Function
    },
    isAlias: {
      type: Boolean,
      default: false
    },
    applyDisable: {
      type: Boolean,
      required: false,
      default: false
    },
    applyClearable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      loading: false,
      disabled: false,
      input: "",
      id: `autocomplete${this._uid}`,
      menuClass: `autocompleteMenu${this._uid}`,
      pHolder: null
    };
  },
  created() {
    this.pHolder = this.placeholder ? this.placeholder : this.$t("search");
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.autocomplete.focus();
    });
  },
  watch: {
    items: {
      deep: true,
      handler() {
        this.loading = false;
        this.handleMenuWidth();
      }
    }
  },
  computed: {
    aliasContent() {
      if (this.isAlias && this.value.includes(" - ")) {
        let [alias, serviceName] = this.value.split(" - ");
        return `<i style="opacity:0.7;position:relative;z-index:11;" class="font-weight-medium">${alias}</i> -
              ${serviceName}`;
      } else {
        return this.value;
      }
    }
  },
  methods: {
    handleMenuWidth() {
      let inputWidth = document.getElementById(this.id).clientWidth;
      let menu = document.getElementsByClassName(this.menuClass)[0];
      if (menu) {
        menu.style.maxWidth = inputWidth + "px";
      }
    },
    change(ev) {
      if (!this.disabled) {
        this.disabled = true;
        if (ev?.target) ev = ev.target.value;
        this.$emit("search", ev);
        if (this.autocomplete) {
          this.loading = true;
          setTimeout(() => (this.loading = false), 3000);
        }
        setTimeout(() => {
          this.disabled = false;
        }, 1000);
      }
    },
    autocompleteChange(ev) {
      // do nothing if it's an arrow key
      let code = ev.keyCode || ev.which;
      if (ev?.target) ev = ev.target.value;
      if (code == 37 || code == 38 || code == 39 || code == 40) {
        return;
      } else if (code === 13) {
        this.$emit("search", ev);
        this.$refs.autocomplete.blur();
      } else {
        this.$emit("autocomplete", ev);
        if (this.autocomplete) {
          this.loading = true;
          setTimeout(() => (this.loading = false), 3000);
        }
      }
    }
  }
};
</script>

<style scoped>
.search-wrapper {
  position: relative;
  width: 100%;
}
.v-autocomplete >>> .v-input__slot,
.v-text-field >>> .v-input__slot {
  background: white;
  padding: 5px !important;
  border-radius: 2px !important;
  flex: 1 1 100% !important;
}
.v-autocomplete >>> .v-input__slot::before {
  display: none;
}
.v-text-field {
  margin-top: 0;
  padding-top: 0;
}
.v-text-field >>> input {
  margin: 0;
}
.v-text-field >>> .v-input__slot {
  border-radius: 2px !important;
}
.v-text-field >>> .v-text-field__details {
  display: none;
}
.v-text-field >>> .v-input__append-inner .v-icon {
  color: var(--primary) !important;
}
.autocomplete-wrapper {
  position: relative;
}
</style>

<style>
.v-autocomplete__content > .v-select-list.v-list {
  padding: 0 !important;
}
.v-autocomplete__content > .v-select-list.v-list div > .v-list__tile {
  border-bottom: solid 0.3px #ccc !important;
}
.search-wrapper
  > .results-autocomplete
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  input {
  margin-top: 0px !important;
}
.v-autocomplete__content
  > .v-select-list
  > .v-list
  div:last-child
  > .v-list__tile {
  border-bottom: none !important;
}
.v-autocomplete__content {
  border-radius: 6px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px var(--white);
  background-color: var(--white);
}
</style>
